import { store } from '@/store'
/**
 * Takes an organizationId and returns
 * all the countries that are available
 * to that organization
 * TODO: allowed countries should be saved and controlled
 * in db, not hardcoded
 * @param {Number} organizationId
 * @returns
 */
export default async (frameworkId) => {
  const allowedCountries = ['DK', 'SE', 'NO']
  const countries = await store.dispatch('countries/find')
  const allAvailableCountries = countries.data.filter(c => allowedCountries.includes(c.code))
  if (!frameworkId) {
    return JSON.parse(JSON.stringify(allAvailableCountries))
  }
  const framework = await store.dispatch('frameworks/get', frameworkId)
  if (!framework) {
    console.error('Failed to get framework')
  }
  const frameWorkCountryId = framework.countryId
  if (frameWorkCountryId === null) {
    return JSON.parse(JSON.stringify(allAvailableCountries))
  } else {
    const country = allAvailableCountries.find(c => c.id === frameWorkCountryId)
    if (country) {
      return JSON.parse(JSON.stringify([country]))
    } else {
      return JSON.parse(JSON.stringify([]))
    }
  }
}

export const getCountryName = async (countryId) => {
  const countries = await store.dispatch('countries/find')
  const country = countries.data.find(c => c.id === countryId)
  return country ? country.native : ''
}
